import { Link } from "react-router-dom";
import styled from "styled-components";

import Button from "../button/Button";

const Wrapper = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    backdrop-filter: blur(15px);
`;

const Modal = styled.div`
    position: relative;
    width: 400px;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    top: 50%;
    margin-top: -100px;
    left: 50%;
    margin-left: -200px;
    border: 1px solid white;
    border-radius: 1rem;
    background: linear-gradient(145deg, #cacaca, #f0f0f0);
    box-shadow:  10px 10px 30px #bebebe, -10px -10px 30px #ffffff;
`;

const Question = styled.span`
    font-size: 200%;
    color: darkslategray;
    margin-bottom: 30px;
`;

const Flex = styled.div`
    display: flex;
    gap: 30px;
`;

const ModalWindow = ({setModal, isNewGame}) => {

    const question = isNewGame ? 'Start a new game?' : 'Continue last game?';
    const buttons = ['Yes', 'No', String.fromCodePoint(9932)].map(item => {
        return isNewGame ? 
            <Link to="/">
                <Button small>
                    Yes
                </Button>
            </Link> 
            :  
            <Button small>
                Yes
            </Button>;
    });

        return (
            <Wrapper>
                <Modal>
                    <Question>
                        Start a new game?
                    </Question>
                    <Flex>
                        <Link to="/">
                            <Button small>
                                Yes
                            </Button>
                        </Link>
                        <Button small setModal={setModal}>
                            No
                        </Button>
                    </Flex>
                    <Button closeWindow setModal={setModal}>
                        {String.fromCodePoint(9932)}
                    </Button>
                </Modal>
            </Wrapper>
        );
    
}

export default ModalWindow;